import { useEffect, useState } from "react";

export default function StickyToc({ items }) {
  const [active, setActive] = useState(items[0]?.id);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const doc = document.documentElement;
      const total = doc.scrollHeight - window.innerHeight;
      const p = total > 0 ? (window.scrollY / total) * 100 : 0;
      setProgress(Math.min(100, Math.max(0, p)));

      // Find the first section whose top is below 120px (i.e., we passed it)
      let current = items[0]?.id;
      for (const it of items) {
        const el = document.getElementById(it.id);
        if (!el) continue;
        const rect = el.getBoundingClientRect();
        if (rect.top <= 140) current = it.id;
      }
      setActive(current);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [items]);

  return (
    <aside
      data-testid="sticky-toc"
      className="hidden lg:block lg:col-span-3"
    >
      <div className="sticky top-24">
        <div className="ls-overline mb-5">Sommaire</div>

        <div className="relative mb-6">
          <div className="h-px bg-white/10 w-full" />
          <div
            className="absolute left-0 top-0 h-px bg-gradient-to-r from-[#9D00FF] to-[#FF1493] transition-all duration-200"
            style={{ width: `${progress}%` }}
          />
        </div>

        <ul className="space-y-3">
          {items.map((it, i) => {
            const isActive = active === it.id;
            return (
              <li key={it.id}>
                <a
                  href={`#${it.id}`}
                  data-testid={`toc-link-${it.id}`}
                  className={`group flex items-center gap-3 text-sm transition py-1 ${
                    isActive ? "text-white" : "text-white/40 hover:text-white/70"
                  }`}
                >
                  <span
                    className={`font-mono-data text-[11px] transition ${
                      isActive ? "text-[#FF1493]" : "text-white/30"
                    }`}
                  >
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span
                    className={`h-px transition-all ${
                      isActive ? "w-5 bg-[#FF1493]" : "w-2 bg-white/20 group-hover:w-3"
                    }`}
                  />
                  <span>{it.label}</span>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </aside>
  );
}
